<template>
  <div>
    <!-- Modal Upload -->
    <b-modal
      id="modal-upload"
      v-model="modalUpload"
      cancel-variant="outline-secondary"
      hide-footer
      centered
      title="Documents"
    >
      <b-form>
        <div>
          <div class="messages">
            <ul
              v-if="documentsList.length > 0"
              class="list-group"
              style="height:300px;width:100%;overflow-y:scroll"
            >
              <input
                v-model="stockOpnameId"
                type="hidden"
              >
              <li
                v-for="item in documentsList"
                :key="item.document_id"
                class="list-group-item d-flex justify-content-between align-items-center"
                style="cursor: pointer;"
              >
                <span style="font-size:9px">{{ item.document_file_name }}</span>
                <div>
                  <b-button
                    :disabled="item.document_old"
                    variant="primary"
                    size="sm"
                    class="mr-1"
                    @click.stop="viewAttachment(item)"
                  >
                    <feather-icon icon="EyeIcon" />
                  </b-button>
                  <b-button
                    variant="danger"
                    size="sm"
                    @click.stop="deleteAttachment(item)"
                  >
                    <feather-icon icon="TrashIcon" />
                  </b-button>
                </div>
              </li>
            </ul>
            <div v-if="documentsList.length == 0">
              No Files
            </div>
            <br>
            <form
              id="send_file_form"
              method="post"
              action=""
              @submit.prevent="sendDocument"
            >
              <b-row>
                <b-col
cols="11"
md="9"
>
                  <b-form-file
                    id="file"
                    ref="uploadFile"
                    placeholder="Choose one file or drop it here..."
                    drop-placeholder="Drop a file here..."
                    type="file"
                    @change="handleFilesUpload"
                  />
                  <div
class="alert alert-info"
role="alert"
>
                    Max file upload is 20MB
                  </div>
                </b-col>
                <b-col
cols="11"
md="3"
>
                  <input
                    type="button"
                    class="btn btn-primary pull-right"
                    value="Send"
                    @click="sendDocument()"
                  >
                </b-col>
              </b-row>
            </form>
          </div>
        </div>
      </b-form>
    </b-modal>

    <!-- Table Container Card -->
    <b-card
no-body
class="mb-0"
>
      <b-tabs v-model="activeTab">
        <!-- ─── Pending Tab ─────────────────────────────────────────── -->
        <b-tab title="Pending">
          <div class="m-2">
            <b-row>
              <!-- Per Page -->
              <b-col
                cols="12"
                md="6"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
              >
                <label>Show</label>
                <v-select
                  v-model="perPage"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
                />
                <label>entries</label>
              </b-col>
              <b-col
cols="12"
md="6"
>
                <div class="d-flex align-items-center justify-content-end">
                  <b-form-input
                    v-model="searchQuery"
                    class="d-inline-block mr-1"
                    placeholder="Search..."
                  />
                  <b-button
                    v-if="userRole == 'finance'"
                    variant="primary"
                    @click="addNew()"
                  >
                    <span class="text-nowrap">Add Stock Opname</span>
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </div>
          <b-table
            ref="refStockOpnameListTable"
            class="position-relative"
            :items="fetchStockOpnames"
            responsive
            :fields="tableColumns"
            primary-key="id"
            :sort-by.sync="sortBy"
            show-empty
            empty-text="No matching records found"
            :sort-desc.sync="isSortDirDesc"
            :busy="loading"
          >
            <template #table-busy>
              <b-skeleton-table
                :rows="perPage || 5"
                :columns="tableColumns ? tableColumns.length : 7"
                :table-props="{ bordered: true, striped: true }"
              />
            </template>

            <!-- Column: Number -->
            <template #cell(stock_opname_number)="data">
              <div class="text-nowrap">
                <feather-icon
                  v-if="data.item.stock_opname_is_confirmed_by_lab_manager == null"
                  icon="CircleIcon"
                  class="default"
                />
                <feather-icon
                  v-if="
                    data.item.stock_opname_is_confirmed_by_lab_manager != null &&
                      data.item.stock_opname_is_confirmed_by_administrator == null
                  "
                  icon="CircleIcon"
                  class="warning"
                />
                <feather-icon
                  v-if="data.item.stock_opname_is_confirmed_by_administrator != null"
                  icon="CircleIcon"
                  class="success"
                />
                <feather-icon
                  v-if="data.item.stock_opname_has_files == true"
                  icon="FileIcon"
                />
                &nbsp;
                <span class="align-text-top text-capitalize">{{
                  data.item.stock_opname_number
                }}</span>
              </div>
            </template>
            <!-- Column: Branch -->
            <template #cell(stock_opname_branch_id)="data">
              <div class="text-nowrap">
                <span class="align-text-top text-capitalize">{{
                  data.item.branch.branch_name
                }}</span>
              </div>
            </template>
            <!-- Column: Date -->
            <template #cell(stock_opname_date)="data">
              {{ dateSimple(data.item.stock_opname_date, "YYYY-MM-DD HH:mm:ss") }}
            </template>
            <!-- Column: Hour -->
            <template #cell(stock_opname_hour)="data">
              <div class="text-nowrap">
                <span class="align-text-top text-capitalize">{{
                  data.item.stock_opname_hour
                }}</span>
              </div>
            </template>
            <!-- Column: Description -->
            <template #cell(stock_opname_description)="data">
              <div class="text-nowrap">
                <span class="align-text-top text-capitalize">{{
                  data.item.stock_opname_description
                }}</span>
              </div>
            </template>
            <template #cell(stock_opname_created_time)="data">
              {{
                dateSimple(
                  data.item.stock_opname_created_time,
                  "YYYY-MM-DD HH:mm:ss"
                )
              }}
            </template>
            <!-- Column: Action -->
            <template #cell(Action)="data">
              <b-dropdown
                variant="link"
                no-caret
                :right="$store.state.appConfig.isRTL"
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>

                <b-dropdown-item :to="{ name: 'apps-stock-opname-details', params: { id: data.item.stock_opname_id } }">
                  <feather-icon icon="ZoomInIcon" />
                  <span class="align-middle ml-50">Detail</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="
                    userRole == 'laboratory-manager' &&
                      data.item.stock_opname_is_confirmed_by_lab_manager == NULL
                  "
                  @click="ConfirmStockOpnameByLabManager(data.item)"
                >
                  <feather-icon icon="CheckIcon" />
                  <span class="align-middle ml-50">Confirm</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="
                    userRole == 'administrator' &&
                      data.item.stock_opname_is_confirmed_by_lab_manager == true &&
                      data.item.stock_opname_is_confirmed_by_administrator == NULL
                  "
                  @click="ConfirmStockOpnameByAdministrator(data.item)"
                >
                  <feather-icon icon="CheckIcon" />
                  <span class="align-middle ml-50">Confirm</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="
                    userRole == 'finance' &&
                      data.item.stock_opname_is_confirmed_by_lab_manager == null
                  "
                  @click="editStockOpname(data.item)"
                >
                  <feather-icon icon="Edit2Icon" />
                  <span class="align-middle ml-50">Edit</span>
                </b-dropdown-item>
                <!-- ── Attachments ── -->
                <b-dropdown-item @click="showDocuments(data.item.stock_opname_id)">
                  <feather-icon icon="FileIcon" />
                  <span class="align-middle ml-50">Attachments</span>
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <div class="mx-2 mb-2">
            <b-row>
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span class="text-muted">
                  Showing {{ dataMeta.from }} to {{ dataMeta.to }} of
                  {{ dataMeta.of }} entries
                </span>
                <span style="padding-left: 10px;">
                  <feather-icon icon="CircleIcon" class="default" /> = Just Created,
                  <feather-icon icon="CircleIcon" class="warning" /> = Confirmed By Lab Manager,
                  <feather-icon icon="CircleIcon" class="success" /> = Confirmed By Administrator
                </span>
              </b-col>
              <!-- Pagination -->
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalStockOpnames || (currentPage * perPage)"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                >
                  <template #prev-text>
                    <feather-icon
icon="ChevronLeftIcon"
size="18"
/>
                  </template>
                  <template #next-text>
                    <feather-icon
icon="ChevronRightIcon"
size="18"
/>
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-tab>

        <!-- ─── Needs Approval Tab ──────────────────────────────────── -->
        <b-tab title="Needs Approval">
          <div class="m-2">
            <b-row>
              <!-- Per Page -->
              <b-col
                cols="12"
                md="6"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
              >
                <label>Show</label>
                <v-select
                  v-model="perPageNA"
                  :options="perPageOptionsNA"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
                />
                <label>entries</label>
              </b-col>
              <b-col
cols="12"
md="6"
>
                <div class="d-flex align-items-center justify-content-end">
                  <b-form-input
                    v-model="searchQueryNA"
                    class="d-inline-block mr-1"
                    placeholder="Search..."
                  />
                  <b-button
                    v-if="userRole == 'finance'"
                    variant="primary"
                    @click="addNew()"
                  >
                    <span class="text-nowrap">Add Stock Opname</span>
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </div>
          <b-table
            ref="refStockOpnameListTableNA"
            class="position-relative"
            :items="fetchStockOpnamesNA"
            responsive
            :fields="tableColumns"
            primary-key="id"
            :sort-by.sync="sortByNA"
            show-empty
            empty-text="No matching records found"
            :sort-desc.sync="isSortDirDescNA"
            :busy="loadingNA"
          >
            <template #table-busy>
              <b-skeleton-table
                :rows="perPageNA || 5"
                :columns="tableColumns ? tableColumns.length : 7"
                :table-props="{ bordered: true, striped: true }"
              />
            </template>

            <!-- Column: Number -->
            <template #cell(stock_opname_number)="data">
              <div class="text-nowrap">
                <feather-icon
                  v-if="data.item.stock_opname_is_confirmed_by_lab_manager == null"
                  icon="CircleIcon"
                  class="default"
                />
                <feather-icon
                  v-if="
                    data.item.stock_opname_is_confirmed_by_lab_manager != null &&
                      data.item.stock_opname_is_confirmed_by_administrator == null
                  "
                  icon="CircleIcon"
                  class="warning"
                />
                <feather-icon
                  v-if="data.item.stock_opname_is_confirmed_by_administrator != null"
                  icon="CircleIcon"
                  class="success"
                />
                <feather-icon
                  v-if="data.item.stock_opname_has_files == true"
                  icon="FileIcon"
                />
                &nbsp;
                <span class="align-text-top text-capitalize">{{
                  data.item.stock_opname_number
                }}</span>
              </div>
            </template>
            <!-- Column: Branch -->
            <template #cell(stock_opname_branch_id)="data">
              <div class="text-nowrap">
                <span class="align-text-top text-capitalize">{{
                  data.item.branch.branch_name
                }}</span>
              </div>
            </template>
            <!-- Column: Date -->
            <template #cell(stock_opname_date)="data">
              {{ dateSimple(data.item.stock_opname_date, "YYYY-MM-DD HH:mm:ss") }}
            </template>
            <!-- Column: Hour -->
            <template #cell(stock_opname_hour)="data">
              <div class="text-nowrap">
                <span class="align-text-top text-capitalize">{{
                  data.item.stock_opname_hour
                }}</span>
              </div>
            </template>
            <!-- Column: Description -->
            <template #cell(stock_opname_description)="data">
              <div class="text-nowrap">
                <span class="align-text-top text-capitalize">{{
                  data.item.stock_opname_description
                }}</span>
              </div>
            </template>
            <template #cell(stock_opname_created_time)="data">
              {{
                dateSimple(
                  data.item.stock_opname_created_time,
                  "YYYY-MM-DD HH:mm:ss"
                )
              }}
            </template>
            <!-- Column: Action -->
            <template #cell(Action)="data">
              <b-dropdown
                variant="link"
                no-caret
                :right="$store.state.appConfig.isRTL"
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>

                <b-dropdown-item :to="{ name: 'apps-stock-opname-details', params: { id: data.item.stock_opname_id } }">
                  <feather-icon icon="ZoomInIcon" />
                  <span class="align-middle ml-50">Detail</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="
                    userRole == 'laboratory-manager' &&
                      data.item.stock_opname_is_confirmed_by_lab_manager == NULL
                  "
                  @click="ConfirmStockOpnameByLabManager(data.item)"
                >
                  <feather-icon icon="CheckIcon" />
                  <span class="align-middle ml-50">Confirm</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="
                    userRole == 'administrator' &&
                      data.item.stock_opname_is_confirmed_by_lab_manager == true &&
                      data.item.stock_opname_is_confirmed_by_administrator == NULL
                  "
                  @click="ConfirmStockOpnameByAdministrator(data.item)"
                >
                  <feather-icon icon="CheckIcon" />
                  <span class="align-middle ml-50">Confirm</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="
                    userRole == 'finance' &&
                      data.item.stock_opname_is_confirmed_by_lab_manager == null
                  "
                  @click="editStockOpname(data.item)"
                >
                  <feather-icon icon="Edit2Icon" />
                  <span class="align-middle ml-50">Edit</span>
                </b-dropdown-item>
                <!-- ── Attachments ── -->
                <b-dropdown-item @click="showDocuments(data.item.stock_opname_id)">
                  <feather-icon icon="FileIcon" />
                  <span class="align-middle ml-50">Attachments</span>
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <div class="mx-2 mb-2">
            <b-row>
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span class="text-muted">
                  Showing {{ dataMetaNA.from }} to {{ dataMetaNA.to }} of
                  {{ dataMetaNA.of }} entries
                </span>
                <span style="padding-left: 10px;">
                  <feather-icon icon="CircleIcon" class="default" /> = Just Created,
                  <feather-icon icon="CircleIcon" class="warning" /> = Confirmed By Lab Manager,
                  <feather-icon icon="CircleIcon" class="success" /> = Confirmed By Administrator
                </span>
              </b-col>
              <!-- Pagination -->
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >
                <b-pagination
                  v-model="currentPageNA"
                  :total-rows="totalStockOpnamesNA || (currentPageNA * perPageNA)"
                  :per-page="perPageNA"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                >
                  <template #prev-text>
                    <feather-icon
icon="ChevronLeftIcon"
size="18"
/>
                  </template>
                  <template #next-text>
                    <feather-icon
icon="ChevronRightIcon"
size="18"
/>
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-tab>

        <!-- ─── Finished Tab ────────────────────────────────────────── -->
        <b-tab title="Finished">
          <div class="m-2">
            <b-row>
              <!-- Per Page -->
              <b-col
                cols="12"
                md="6"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
              >
                <label>Show</label>
                <v-select
                  v-model="perPageFinished"
                  :options="perPageOptionsFinished"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
                />
                <label>entries</label>
              </b-col>
              <b-col
cols="12"
md="6"
>
                <div class="d-flex align-items-center justify-content-end">
                  <b-form-input
                    v-model="searchQueryFinished"
                    class="d-inline-block mr-1"
                    placeholder="Search..."
                  />
                  <b-button
                    v-if="userRole == 'finance'"
                    variant="primary"
                    @click="addNew()"
                  >
                    <span class="text-nowrap">Add Stock Opname</span>
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </div>
          <b-table
            ref="refStockOpnameListTableFinished"
            class="position-relative"
            :items="fetchStockOpnamesFinished"
            responsive
            :fields="tableColumns"
            primary-key="id"
            :sort-by.sync="sortByFinished"
            show-empty
            empty-text="No matching records found"
            :sort-desc.sync="isSortDirDescFinished"
            :busy="loadingFinished"
          >
            <template #table-busy>
              <b-skeleton-table
                :rows="perPageFinished || 5"
                :columns="tableColumns ? tableColumns.length : 7"
                :table-props="{ bordered: true, striped: true }"
              />
            </template>

            <!-- Column: Number -->
            <template #cell(stock_opname_number)="data">
              <div class="text-nowrap">
                <feather-icon
                  v-if="data.item.stock_opname_is_confirmed_by_lab_manager == null"
                  icon="CircleIcon"
                  class="default"
                />
                <feather-icon
                  v-if="
                    data.item.stock_opname_is_confirmed_by_lab_manager != null &&
                      data.item.stock_opname_is_confirmed_by_administrator == null
                  "
                  icon="CircleIcon"
                  class="warning"
                />
                <feather-icon
                  v-if="data.item.stock_opname_is_confirmed_by_administrator != null"
                  icon="CircleIcon"
                  class="success"
                />
                <feather-icon
                  v-if="data.item.stock_opname_has_files == true"
                  icon="FileIcon"
                />
                &nbsp;
                <span class="align-text-top text-capitalize">{{
                  data.item.stock_opname_number
                }}</span>
              </div>
            </template>
            <!-- Column: Branch -->
            <template #cell(stock_opname_branch_id)="data">
              <div class="text-nowrap">
                <span class="align-text-top text-capitalize">{{
                  data.item.branch.branch_name
                }}</span>
              </div>
            </template>
            <!-- Column: Date -->
            <template #cell(stock_opname_date)="data">
              {{ dateSimple(data.item.stock_opname_date, "YYYY-MM-DD HH:mm:ss") }}
            </template>
            <!-- Column: Hour -->
            <template #cell(stock_opname_hour)="data">
              <div class="text-nowrap">
                <span class="align-text-top text-capitalize">{{
                  data.item.stock_opname_hour
                }}</span>
              </div>
            </template>
            <!-- Column: Description -->
            <template #cell(stock_opname_description)="data">
              <div class="text-nowrap">
                <span class="align-text-top text-capitalize">{{
                  data.item.stock_opname_description
                }}</span>
              </div>
            </template>
            <template #cell(stock_opname_created_time)="data">
              {{
                dateSimple(
                  data.item.stock_opname_created_time,
                  "YYYY-MM-DD HH:mm:ss"
                )
              }}
            </template>
            <!-- Column: Action -->
            <template #cell(Action)="data">
              <b-dropdown
                variant="link"
                no-caret
                :right="$store.state.appConfig.isRTL"
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>

                <b-dropdown-item :to="{ name: 'apps-stock-opname-details', params: { id: data.item.stock_opname_id } }">
                  <feather-icon icon="ZoomInIcon" />
                  <span class="align-middle ml-50">Detail</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="
                    userRole == 'laboratory-manager' &&
                      data.item.stock_opname_is_confirmed_by_lab_manager == NULL
                  "
                  @click="ConfirmStockOpnameByLabManager(data.item)"
                >
                  <feather-icon icon="CheckIcon" />
                  <span class="align-middle ml-50">Confirm</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="
                    userRole == 'administrator' &&
                      data.item.stock_opname_is_confirmed_by_lab_manager == true &&
                      data.item.stock_opname_is_confirmed_by_administrator == NULL
                  "
                  @click="ConfirmStockOpnameByAdministrator(data.item)"
                >
                  <feather-icon icon="CheckIcon" />
                  <span class="align-middle ml-50">Confirm</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="
                    userRole == 'finance' &&
                      data.item.stock_opname_is_confirmed_by_lab_manager == null
                  "
                  @click="editStockOpname(data.item)"
                >
                  <feather-icon icon="Edit2Icon" />
                  <span class="align-middle ml-50">Edit</span>
                </b-dropdown-item>
                <!-- ── Attachments ── -->
                <b-dropdown-item @click="showDocuments(data.item.stock_opname_id)">
                  <feather-icon icon="FileIcon" />
                  <span class="align-middle ml-50">Attachments</span>
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <div class="mx-2 mb-2">
            <b-row>
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span class="text-muted">
                  Showing {{ dataMetaFinished.from }} to {{ dataMetaFinished.to }} of
                  {{ dataMetaFinished.of }} entries
                </span>
                <span style="padding-left: 10px;">
                  <feather-icon icon="CircleIcon" class="default" /> = Just Created,
                  <feather-icon icon="CircleIcon" class="warning" /> = Confirmed By Lab Manager,
                  <feather-icon icon="CircleIcon" class="success" /> = Confirmed By Administrator
                </span>
              </b-col>
              <!-- Pagination -->
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >
                <b-pagination
                  v-model="currentPageFinished"
                  :total-rows="totalStockOpnamesFinished || (currentPageFinished * perPageFinished)"
                  :per-page="perPageFinished"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                >
                  <template #prev-text>
                    <feather-icon
icon="ChevronLeftIcon"
size="18"
/>
                  </template>
                  <template #next-text>
                    <feather-icon
icon="ChevronRightIcon"
size="18"
/>
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BModal,
  VBModal,
  BListGroup,
  BTabs,
  BTab,
  BListGroupItem,
  BFormFile,
  BForm,
} from "bootstrap-vue"
import axios from "axios"
import vSelect from "vue-select"
import store from "@/store"
import { getUserData } from "@/auth/utils"
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue"
import { ref, onUnmounted } from "@vue/composition-api"
import { avatarText } from "@core/utils/filter"
import moment from "moment-timezone"
import { VueHorizontalTimeline } from "vue-horizontal-timeline"
import apiEndpoints from '@/constants/apiEndpoints'
import listPagePersistence from "@/mixins/listPagePersistence"
import StockOpnameList from "./List"

const userRole = ""
const messageBox = ""
const to = ""
const cc = ""
const reason = ""
const StockOpnameId = ""
const messagesList = []
const statusItems = []
const items = []
const userId = getUserData().user_id
const modalDetailShow = false
const modalMessage = false

// Attachment-related state
const file = ""
const modalUpload = false
const documentsList = []
const stockOpnameId = ""

export default {
  components: {
    BTabs,
    BTab,
    VueHorizontalTimeline,
    BListGroup,
    BListGroupItem,
    BModal,
    VBModal,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormFile,
    BForm,
    vSelect,
  },
  mixins: [listPagePersistence(['currentPage', 'currentPageFinished', 'currentPageNA', 'activeTab'])],
  data() {
    return {
      activeTab: 0,
      items,
      statusItems,
      StockOpnameId,
      userId,
      messagesList,
      // Attachment data
      file,
      modalUpload,
      documentsList,
      stockOpnameId,
    }
  },
  mounted() {
    this.userRole = this.$cookies.get("UserRole")
    this.$root.$on("refreshTable", text => {
      if (this.$refs.refStockOpnameListTable) this.$refs.refStockOpnameListTable.refresh()
      if (this.$refs.refStockOpnameListTableNA) this.$refs.refStockOpnameListTableNA.refresh()
      if (this.$refs.refStockOpnameListTableFinished) this.$refs.refStockOpnameListTableFinished.refresh()
    })
  },
  setup() {
    const BRANCH_APP_STORE_MODULE_NAME = "app-transfers"
    onUnmounted(() => {
      if (store.hasModule(BRANCH_APP_STORE_MODULE_NAME)) {
        store.unregisterModule(BRANCH_APP_STORE_MODULE_NAME)
      }
    })

    const isAddNewStockOpnameSidebarActive = ref(false)

    const statusOptions = [
      { label: "Pending", value: "pending" },
      { label: "Active", value: "active" },
      { label: "Inactive", value: "inactive" },
    ]

    const {
      fetchStockOpnames,
      fetchStockOpnamesNA,
      fetchStockOpnamesFinished,
      loading,
      loadingNA,
      loadingFinished,
      tableColumns,
      perPage,
      currentPage,
      totalStockOpnames,
      dataMeta,
      dataMetaNA,
      dataMetaFinished,
      perPageOptions,
      perPageOptionsNA,
      perPageOptionsFinished,
      searchQuery,
      searchQueryNA,
      searchQueryFinished,
      sortBy,
      sortByNA,
      sortByFinished,
      isSortDirDesc,
      isSortDirDescNA,
      isSortDirDescFinished,
      refStockOpnameListTable,
      refStockOpnameListTableNA,
      refStockOpnameListTableFinished,
      perPageNA,
      currentPageNA,
      totalStockOpnamesNA,
      totalStockOpnamesFinished,
      perPageFinished,
      currentPageFinished,
      refetchData,
      resolveStockOpnameRoleVariant,
      resolveStockOpnameRoleIcon,
      resolveStockOpnameStatusVariant,
      roleFilter,
      statusFilter,
    } = StockOpnameList()

    const roleOptions = [
      { label: "Admin", value: "admin" },
      { label: "Author", value: "author" },
      { label: "Editor", value: "editor" },
      { label: "Maintainer", value: "maintainer" },
      { label: "Subscriber", value: "subscriber" },
    ]

    return {
      to,
      cc,
      reason,
      messageBox,
      modalDetailShow,
      modalMessage,
      isAddNewStockOpnameSidebarActive,
      userRole,
      fetchStockOpnames,
      fetchStockOpnamesNA,
      fetchStockOpnamesFinished,
      loading,
      loadingNA,
      loadingFinished,
      tableColumns,
      perPage,
      currentPage,
      totalStockOpnames,
      dataMeta,
      dataMetaNA,
      dataMetaFinished,
      perPageOptions,
      perPageOptionsNA,
      perPageOptionsFinished,
      searchQuery,
      searchQueryNA,
      searchQueryFinished,
      sortBy,
      sortByNA,
      sortByFinished,
      isSortDirDesc,
      isSortDirDescNA,
      isSortDirDescFinished,
      refStockOpnameListTable,
      refStockOpnameListTableNA,
      refStockOpnameListTableFinished,
      perPageNA,
      currentPageNA,
      totalStockOpnamesNA,
      totalStockOpnamesFinished,
      perPageFinished,
      currentPageFinished,
      refetchData,
      avatarText,
      resolveStockOpnameRoleVariant,
      resolveStockOpnameRoleIcon,
      resolveStockOpnameStatusVariant,
      roleOptions,
      statusOptions,
      roleFilter,
      statusFilter,
    }
  },
  methods: {
    // ─── Attachment Methods ──────────────────────────────────────────
    showDocuments(id) {
      const userToken = this.$cookies.get("userToken")
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      }
      this.stockOpnameId = id
      this.modalUpload = true
      axios
        .get(
          `${process.env.VUE_APP_API_URL}${apiEndpoints.API_GET_DOCUMENTS}stock-opname/${id}`,
          { headers },
        )
        .then(response => {
          if (response.data.success === true) {
            if (response.data.data) {
              this.documentsList.splice(0, this.documentsList.length)
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Fetching Documents success",
                  icon: "CheckIcon",
                  variant: "success",
                },
              })
              response.data.data.map(value => {
                this.documentsList.push(value)
              })
            }
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Fetching Documents failed",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            })
          }
        })
    },
    handleFilesUpload(e) {
      this.file = e.target.files || e.dataTransfer.files
    },
    sendDocument() {
      const userToken = this.$cookies.get("userToken")
      const header = {
        "Content-Type": "multipart/form-dataitem",
        Authorization: `Bearer ${userToken}`,
      }
      const formData = new FormData()
      if (typeof this.file[0] !== "undefined") {
        formData.append("file", this.file[0], this.file[0].name)
        formData.append("document_stock_opname_id", this.stockOpnameId)
        formData.append("time", moment())
        axios
          .post(
            `${process.env.VUE_APP_API_URL}${apiEndpoints.API_CREATE_DOCUMENT}`,
            formData,
            { headers: header },
          )
          .then(async response => {
            if (response.data.success === true) {
              if (this.$refs.refStockOpnameListTable) this.$refs.refStockOpnameListTable.refresh()
              if (this.$refs.refStockOpnameListTableNA) this.$refs.refStockOpnameListTableNA.refresh()
              if (this.$refs.refStockOpnameListTableFinished) this.$refs.refStockOpnameListTableFinished.refresh()
              this.$refs.uploadFile.reset()
              // Refresh documents list in modal
              axios
                .get(
                  `${process.env.VUE_APP_API_URL}${apiEndpoints.API_GET_DOCUMENTS}stock-opname/${this.stockOpnameId}`,
                  { headers: header },
                )
                .then(response2 => {
                  if (response2.data.success === true && response2.data.data) {
                    this.documentsList.splice(0, this.documentsList.length)
                    response2.data.data.map(value => {
                      this.documentsList.push(value)
                    })
                  }
                })
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Upload Document Success",
                  icon: "CheckIcon",
                  variant: "success",
                },
              })
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Something went wrong",
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              })
            }
          })
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Please Upload The Document!",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        })
      }
    },
    viewAttachment(document) {
      const userToken = this.$cookies.get("userToken")
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      }
      const FileName = document.document_file_name
      const ObjectName = `${document.document_number}${FileName}`
      const body = { ObjectName, FileName }
      axios
        .post(
          `${process.env.VUE_APP_API_URL}${apiEndpoints.API_DOWNLOAD_ASSET}`,
          body,
          { headers },
        )
        .then(response => {
          if (response.data.Status === 1) {
            const fileUrl = response.data.Payload
            fetch(fileUrl)
              .then(res => res.blob())
              .then(blob => {
                const blobUrl = window.URL.createObjectURL(blob)
                window.open(blobUrl, "_blank")
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Document opened successfully",
                    icon: "CheckIcon",
                    variant: "success",
                  },
                })
              })
              .catch(error => {
                console.error("Error fetching blob:", error)
                window.open(fileUrl, "_blank")
              })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Something went wrong",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            })
          }
        })
    },
    deleteAttachment(document) {
      const userToken = this.$cookies.get("userToken")
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      }
      axios
        .get(
          `${process.env.VUE_APP_API_URL}${apiEndpoints.API_DELETE_DOCUMENT}`,
          { params: { id: document.document_id }, headers },
        )
        .then(response => {
          if (response.data.success === true) {
            this.showDocuments(this.stockOpnameId)
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Delete Attachment success",
                icon: "CheckIcon",
                variant: "success",
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.Message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            })
          }
        })
    },

    // ─── Existing Methods ────────────────────────────────────────────
    deleteStockOpname(id) {
      const userToken = this.$cookies.get("userToken")
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      }
      axios
        .get(`${process.env.VUE_APP_API_DELETE_TRANSFER}${id}`, { headers })
        .then(response => {
          if (response.data.success === true) {
            if (this.$refs.refStockOpnameListTable) this.$refs.refStockOpnameListTable.refresh()
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Congratulation",
                icon: "CoffeeIcon",
                variant: "success",
                text: "Your data has been deleted!",
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Notification",
                icon: "BellIcon",
                variant: "danger",
                text: "Something went wrong",
              },
            })
          }
        })
        .catch(err => {

        })
    },
    editStockOpname(data) {
      localStorage.setItem("StockOpnameDetail", JSON.stringify(data))
      this.$router.push({ name: "apps-stock-opname-edit" })
    },
    declineStockOpname(id) {
      const userToken = this.$cookies.get("userToken")
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      }
      const body = { time: moment() }
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/transactions/stock_opname/decline/${id}`,
          body,
          { headers },
        )
        .then(async response => {
          if (response.data.success === true) {
            if (this.$refs.refStockOpnameListTable) this.$refs.refStockOpnameListTable.refresh()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Confirm Stock Opname Success",
                icon: "CheckIcon",
                variant: "success",
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Something went wrong",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            })
          }
        })
    },
    ConfirmStockOpnameByFinance(data) {
      localStorage.setItem("StockOpnameDetail", JSON.stringify(data))
      this.$router.push({ name: "apps-stock-opname-confirm-finance" })
    },
    ConfirmStockOpnameByLabManager(data) {
      localStorage.setItem("StockOpnameDetail", JSON.stringify(data))
      this.$router.push({ name: "apps-stock-opname-confirm-labmanager" })
    },
    ConfirmStockOpnameByAdministrator(data) {
      localStorage.setItem("StockOpnameDetail", JSON.stringify(data))
      this.$router.push({ name: "apps-stock-opname-confirm-administrator" })
    },
    addNew() {
      this.$router.push({ name: "apps-stock-opname-create" })
    },
    dateSimple(value, format = "YYYY-MM-DD") {
      let dateRet = ""
      if (value !== null) {
        dateRet = moment.utc(value).tz("Asia/Jakarta").format(format)
      } else {
        dateRet = null
      }
      return dateRet
    },
    showDetail(item) {
      localStorage.setItem("StockOpnameDetail", JSON.stringify(item))
      this.$router.push({ name: "apps-stock-opname-details" })
    },
    hasPermission(permission) {
      const cookieVal = this.$cookies.get("userPermissions")
      const permissions = (cookieVal || "").split(",")
      return permissions.includes(permission)
    },
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
